import React from "react";
import { Box } from "@mui/material";

import StickyTabs from "./StickyTabs";
import ConsoleEmptyState from "./ConsoleEmptyState";

const ConsolePanel = ({
  theme,
  tabs,
  activeTab,
  onTabChange,
  onCloseTab,
  renderComponent,
}) => {
  return (
    <Box
      component='main'
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minWidth: 0,
        minHeight: 0,
        width: "100%",
        height: "100%",
        overflow: "hidden", // Prevent main container from scrolling
        position: "relative", // Ensure proper positioning
      }}
      aria-label='Main content area'
    >
      {/* Sticky Tabs - No Scrollbar */}
      {tabs.length > 0 && (
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            bgcolor: "background.paper",
            boxShadow: 1,
          }}
        >
          <StickyTabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
            onCloseTab={onCloseTab}
          />
        </Box>
      )}

      {/* Content Area with Proper Scrolling */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            width: "10px",
            height: "10px",
          },
          "&::-webkit-scrollbar-track": {
            background: theme.palette.background.paper,
            borderRadius: "5px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: theme.palette.primary.main,
            borderRadius: "5px",
            border: `2px solid ${theme.palette.background.paper}`,
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#4F337A",
          },
          "&::-webkit-scrollbar-thumb:active": {
            background: theme.palette.secondary.main,
          },
          "&::-webkit-scrollbar-corner": {
            background: theme.palette.background.paper,
          },
        }}
      >
        {tabs.length > 0 ? (
          renderComponent(tabs[activeTab]?.component)
        ) : (
          <ConsoleEmptyState />
        )}
      </Box>
    </Box>
  );
};

export default ConsolePanel;
